export enum EventReservationType {
    Tables = 'Tables',
    Tickets = 'Tickets'
}